import React, { useEffect } from "react";

import {
    Dialog,
    DialogContent,
    DialogTitle,
    Button,
    TextField,
    Typography,
    Box,
    Divider,
    Stack,
    IconButton
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

function ProfileDialog({
    open,
    onClose,
    onLogout,
    fullScreen,
    userName,
    userEmail,
    messagesRemaining,
    version,
    onSendFeedback,
    sendingFeedback
}) {
    const [feedback, setFeedback] = React.useState("");

    const handleSendFeedback = () => {
        if (onSendFeedback) {
            onSendFeedback(feedback);
        }
        setFeedback("");
    };

    useEffect(() => {
    }, [])

    return (
        <Dialog
            fullScreen={fullScreen}
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>
                <Stack
                    direction={"row"}
                    alignItems={"center"}
                >
                    <Stack>
                        <Typography
                            variant="h6">
                            My Profile
                        </Typography>
                        <Typography
                            sx={{
                                alignSelf: "end",
                            }}
                            variant="caption" color="textSecondary">
                            Version: {version}
                        </Typography>
                    </Stack>
                    <Box sx={{ flexGrow: 1 }} />
                    <IconButton
                        onClick={onClose}
                    >
                        <CloseIcon />
                    </IconButton>
                </Stack>
            </DialogTitle>
            <DialogContent>
                <Box mb={2}>
                    <Typography variant="body1">
                        {userName}
                    </Typography>
                    <Typography variant="body1">
                        {userEmail}
                    </Typography>
                    <Typography variant="body1">
                        <strong>{messagesRemaining}</strong> messages remaining
                    </Typography>
                </Box>

                <Divider />

                <Box mt={2}>
                    <Typography variant="h6" gutterBottom>
                        Feedback or Report an issue
                    </Typography>
                    <TextField
                        multiline
                        rows={4}
                        variant="outlined"
                        fullWidth
                        placeholder="Describe your issue or feedback here..."
                        value={feedback}
                        onChange={(e) => setFeedback(e.target.value)}
                    />
                    <Stack
                        direction={"row"}
                        alignContent={"center"}
                        mt={1}
                        spacing={1}
                    >
                        <Button
                            variant="contained"
                            onClick={onLogout}
                            color="error">
                            Logout
                        </Button>
                        <Box sx={{ flexGrow: 1 }} />
                        <Button
                            disabled={!feedback.trim() || sendingFeedback}
                            variant="contained"
                            color="primary"
                            onClick={handleSendFeedback}
                        >
                            Send
                        </Button>
                    </Stack>
                </Box>
            </DialogContent>

        </Dialog >
    );
}

export default ProfileDialog;
